export default "__VITE_ASSET__Ildc8zsf__"